import React, { useEffect, useState } from "react"

import { FaArrowLeft, FaCheck } from "../../../../AppReactIcons"
import { DarkAppButton, GreenAppButton } from "../../../buttons"
import SidebarWrapper from "../../MyDashboard/Applets/Utils/SidebarWrapper"
import { ContentSeparator } from "../../Utils/ContentSeparator"

interface iReasonsPanel {
  show: boolean
  toggleShow: (open: boolean) => void
  onSubmit: (reasons: string[]) => void
  reasonsList: string[]
  title: string
}

const Option: React.FC<{
  text: string
  selected: boolean
  onClick: () => void
}> = ({ text, selected, onClick }) => {
  return (
    <div className="flex mb-2">
      <div
        onClick={onClick}
        className={`${
          selected
            ? "bg-site-green text-white"
            : "bg-gray-200 text-site-blue-dark"
        } rounded-lg px-4 py-1 hover:shadow cursor-pointer transition duration-100`}
      >
        <p className="flex items-center ">
          {selected && (
            <span className="mr-2">
              <FaCheck />
            </span>
          )}
          <span>{text}</span>
        </p>
      </div>
    </div>
  )
}

const ReasonsPanel: React.FC<iReasonsPanel> = ({
  show,
  toggleShow,
  onSubmit,
  reasonsList,
  title,
}) => {
  const [selectedReasonsList, setSelectedReasonsList] = useState<string[]>([])
  useEffect(() => {
    setSelectedReasonsList([])
  }, [reasonsList])
  const onClickOption = (option: string) => {
    if (selectedReasonsList.includes(option)) {
      setSelectedReasonsList(selectedReasonsList.filter(item => item != option))
      return
    }
    setSelectedReasonsList([...selectedReasonsList, option])
  }

  return (
    <SidebarWrapper sidebarOpen={show} onToggleSidebar={toggleShow}>
      <div className="overflow-y-auto p-8">
        <GreenAppButton
          title="Go back"
          Icon={<FaArrowLeft />}
          onClick={() => toggleShow(false)}
        />
        <ContentSeparator />
        <ContentSeparator />
        <h1 className="text-3xl text-site-blue-dark mb-2">{title}</h1>
        <p>
          Please select one or more responses from the following (optional).
        </p>
        <ContentSeparator />
        {reasonsList.map((item, index) => (
          <Option
            key={index}
            text={item}
            selected={selectedReasonsList.includes(item)}
            onClick={() => onClickOption(item)}
          />
        ))}
        <ContentSeparator />
        <DarkAppButton
          title="Submit my response"
          onClick={() => onSubmit(reasonsList)}
        />
      </div>
    </SidebarWrapper>
  )
}

export default ReasonsPanel
